import React, { createContext, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4200";

const AuthContext = createContext()

export const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();

  const verifyAuth = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/admin/checklogin`, {
        withCredentials: true
      });

      if (response.data.success) {
        setUser(response.data.data);
        // navigate("/dashboard"); // Don't auto-navigate here, let the Route decide
      } else {
        setUser(null);
        localStorage.removeItem("InfinexAdminUser");
      }
    } catch (error) {
      console.error("Auth verification failed:", error);
      setUser(null);
      localStorage.removeItem("InfinexAdminUser");
    } finally {
      setLoading(false);
    }
  };

  const checkLogin = () => {
    verifyAuth();
  }

  const logOut = async () => {
    try {
      await axios.get(`${API_URL}/admin/logout`, { withCredentials: true });
    } catch (error) {
      console.error("Logout error", error);
    }
    // Clear both storage types to be safe
    localStorage.removeItem("InfinexAdminUser");
    sessionStorage.removeItem("InfinexAdminUser");

    setUser(null);
    navigate("/login");
  }

  // Initial check on mount
  // We don't want to force checkLogin on every mount of Provider if we already have user
  // ensuring persistence across reloads
  useEffect(() => {
    verifyAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkLogin, logOut }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
